var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueHistorie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Historie"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 998",
    cx: 9,
    cy: 9,
    r: 8.25,
    stroke: "#026094",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 196",
    d: "M4.5 6C4.5 5.72386 4.72386 5.5 5 5.5H6H6.58579C6.71839 5.5 6.84557 5.55268 6.93934 5.64645L7.29289 5.29289L6.93934 5.64645L7.35355 6.06066C7.63486 6.34197 8.01639 6.5 8.41421 6.5H13C13.2761 6.5 13.5 6.72386 13.5 7V11C13.5 11.2761 13.2761 11.5 13 11.5H5C4.72386 11.5 4.5 11.2761 4.5 11V7V6Z",
    stroke: "#026094"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHistorie);
export default __webpack_public_path__ + "static/media/BlueHistorie.467c1e84d9a18f373a55ca669decde20.svg";
export { ForwardRef as ReactComponent };